
import React from 'react';
import { MobileNavigationItemProps } from './types';
import { MobileNavigationMegaMenuItem } from './MobileNavigationMegaMenuItem';
import { MobileNavigationDropdownItem } from './MobileNavigationDropdownItem';
import { MobileNavigationLinkItem } from './MobileNavigationLinkItem';

export const MobileNavigationItem: React.FC<MobileNavigationItemProps> = ({
  item,
  isActive,
  expanded,
  onToggleExpand,
  onClose,
  onNavigationClick
}) => {
  if (item.hasMegaMenu) {
    return (
      <MobileNavigationMegaMenuItem
        item={item}
        expanded={expanded}
        onToggleExpand={onToggleExpand}
        onClose={onClose}
        onNavigationClick={onNavigationClick}
      />
    );
  }

  if (item.hasDropdown) {
    return (
      <MobileNavigationDropdownItem
        item={item}
        isActive={isActive}
        expanded={expanded}
        onToggleExpand={onToggleExpand}
        onClose={onClose}
        onNavigationClick={onNavigationClick}
      />
    );
  }

  return (
    <MobileNavigationLinkItem
      item={item}
      isActive={isActive}
      onClose={onClose}
      onNavigationClick={onNavigationClick}
    />
  );
};
